<template>
    <div class="box-name-sidebar px-6" v-if="currentObject && currentObject.name">
        <p>{{currentObject.name}}</p>
    </div>
    <!--begin::sidebar menu-->
    <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
        <!--begin::Menu wrapper-->
        <div id="kt_app_sidebar_menu_wrapper"
             class="app-sidebar-wrapper hover-scroll-overlay-y my-5"
             data-kt-scroll="true"
             data-kt-scroll-activate="true"
             data-kt-scroll-height="auto"
             data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
             data-kt-scroll-wrappers="#kt_app_sidebar_menu"
             data-kt-scroll-offset="5px"
             data-kt-scroll-save-state="true">
            <!--begin::Menu-->
            <div id="#kt_app_sidebar_menu"
                 class="menu menu-column menu-rounded menu-sub-indention px-3"
                 data-kt-menu="true">
                <template v-for="(item, i) in MainMenuConfig" :key="i">
                    <div v-if="item.heading" class="menu-item pt-5">
                        <div class="menu-content">
                            <span class="menu-heading fw-bold text-uppercase fs-7">
                                {{ translate(item.heading) }}
                            </span>
                        </div>
                    </div>
                    <template v-for="(menuItem, j) in item.pages" :key="j">
                        <template v-if="menuItem.heading && checkPemission(menuItem)">
                            <div class="menu-item">
                                <router-link v-if="menuItem.route"
                                             class="menu-link text-menu-sidebar"
                                             active-class="active-sidebar-medcat"
                                             :to="menuItem.route">
                                    <span v-if="menuItem.keenthemesIcon || menuItem.bootstrapIcon"
                                          class="menu-icon">
                                        <i v-if="sidebarMenuIcons === 'bootstrap'"
                                           :class="menuItem.bootstrapIcon"
                                           class="bi fs-3"></i>
                                        <KTIcon v-else-if="sidebarMenuIcons === 'keenthemes'"
                                                :icon-name="menuItem.keenthemesIcon"
                                                icon-class="fs-2" />
                                    </span>
                                    <span class="menu-title fs-6">
                                        {{
                    translate(menuItem.heading)
                                        }}
                                    </span>
                                </router-link>
                            </div>
                        </template>
                        <div v-if="menuItem.sectionTitle && menuItem.route"
                             :class="{ show: hasActiveChildren(menuItem) }"
                             class="menu-item menu-accordion"
                             data-kt-menu-sub="accordion"
                             data-kt-menu-trigger="click">
                            <span class="menu-link">
                                <span v-if="menuItem.keenthemesIcon || menuItem.bootstrapIcon"
                                      class="menu-icon">
                                    <i v-if="sidebarMenuIcons === 'bootstrap'"
                                       :class="menuItem.bootstrapIcon"
                                       class="bi fs-3"></i>
                                    <KTIcon v-else-if="sidebarMenuIcons === 'keenthemes'"
                                            :icon-name="menuItem.keenthemesIcon"
                                            icon-class="fs-2" />
                                </span>
                                <span class="menu-title">
                                    {{
                  translate(menuItem.sectionTitle)
                                    }}
                                </span>
                                <span class="menu-arrow"></span>
                            </span>
                            <div :class="{ show: hasActiveChildren(menuItem) }"
                                 class="menu-sub menu-sub-accordion">
                                <template v-for="(item2, k) in menuItem.sub" :key="k">
                                    <div v-if="item2.heading && checkPemission(item2)" class="menu-item">
                                        <router-link v-if="item2.route"
                                                     class="menu-link "
                                                     active-class="active-sidebar-medcat"
                                                     :to="item2.route">
                                            <span class="menu-bullet">
                                                <span class="bullet bullet-dot"></span>
                                            </span>
                                            <span class="menu-title fs-6 fw-semibold">
                                                {{
                        translate(item2.heading)
                                                }}
                                            </span>
                                            <span class="menu-badge" v-if="item2.route.startsWith('/news/') && newsCount[item2.route.replace('/news/', '')]"></span>
                                        </router-link>
                                    </div>
                                    <div v-if="item2.sectionTitle && item2.route"
                                         class="menu-item menu-accordion"
                                         data-kt-menu-sub="accordion"
                                         data-kt-menu-trigger="click">
                                        <span class="menu-link">
                                            <span class="menu-bullet">
                                                <span class="bullet bullet-dot"></span>
                                            </span>
                                            <span class="menu-title">
                                                {{
                        translate(item2.sectionTitle)
                                                }}
                                            </span>
                                            <span class="menu-arrow"></span>
                                        </span>
                                        <div :class="{ show: hasActiveChildren(item2) }"
                                             class="menu-sub menu-sub-accordion">
                                            <template v-for="(item3, k) in item2.sub" :key="k">
                                                <div v-if="item3.heading" class="menu-item">
                                                    <router-link v-if="item3.route"
                                                                 class="menu-link text-menu-sidebar"
                                                                 active-class="active-sidebar-medcat"
                                                                 :to="item3.route">
                                                        <span class="menu-bullet">
                                                            <span class="bullet bullet-dot"></span>
                                                        </span>
                                                        <span class="menu-title">
                                                            {{
                              translate(item3.heading)
                                                            }}
                                                        </span>
                                                    </router-link>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <!--end::Menu-->
        </div>
        <!--end::Menu wrapper-->
    </div>
    <!--end::sidebar menu-->
</template>

<script lang="ts">
    import { getAssetPath } from "@/core/helpers/assets";
    import { defineComponent, onMounted, ref } from "vue";
    import { useRoute } from "vue-router";
    import { PermissonEnum } from "~/constants/documentEnum";
    import MainMenuConfig from "@/layouts/default-layout/config/MainMenuConfig";
    import { sidebarMenuIcons } from "@/layouts/default-layout/config/helper";
    import { useI18n } from "vue-i18n";
    import { reinitializeComponents } from "@/core/plugins/keenthemes";
    export default defineComponent({
        name: "sidebar-menu",
        components: {},
        setup() {
            const { t, te } = useI18n();
            const route = useRoute();
            const systemStore = useSystemStore();
            const currentObject = ref<null>();
            const scrollElRef = ref<null | HTMLElement>(null);
            const { $isPermission, $userType } = useNuxtApp();
            onMounted(() => {
                if (scrollElRef.value) {
                    scrollElRef.value.scrollTop = 0;
                }
                setTimeout(() => {
                    var listMenu = document.querySelectorAll('#kt_app_sidebar_menu_wrapper .menu > .menu-item');
                    listMenu.forEach(parent => {
                        if (!parent.querySelector('.menu-content')) {
                            const hasMenuLink = parent.querySelector('a.menu-link');
                            if (!hasMenuLink) {
                                parent.remove();
                            }
                        }
                    });
                    //listMenu.forEach(parent => {
                    //    if (parent.querySelector('.menu-content')) {
                    //        const nextElement = parent.nextElementSibling;
                    //        if (!nextElement || (nextElement && !nextElement.classList.contains('menu-accordion'))) {
                    //            parent.remove();
                    //        }
                    //    }
                    //});
                    reinitializeComponents()
                }, 100)

                currentObject.value = systemStore?.systemData?.currentObject;
            });

            const translate = (text: string) => {
                if (te(text)) {
                    return t(text);
                } else {
                    return text;
                }
            };

            const parentItem = computed((): MenuItem | null => {
                function recursiveSearch(items: MenuItem[]): MenuItem | null {
                    for (const item of items) {
                        if (item.pages) {
                            const found = item.pages.find(child => child.route === route.path);
                            if (found) return item; // Trả về item này vì nó là cha trực tiếp
                            const deeper = recursiveSearch(item.pages);
                            if (deeper) return deeper;
                        }

                        if (item.sub) {
                            const found = item.sub.find(child => child.route === route.path);
                            if (found) return item; // Trả về item này vì nó là cha trực tiếp
                            const deeper = recursiveSearch(item.sub);
                            if (deeper) return deeper;
                        }
                    }
                    return null;
                }

                return recursiveSearch(MainMenuConfig);
            });

            const hasActiveChildren = (item) => {
                if (parentItem.value && item.route == parentItem.value.route)
                    return true;
                return false;
            };
            const checkPemission = (item) => {
                if (item && (!item.userTypes || item.userTypes.includes($userType()))) {
                    if (item.module) {
                        return $isPermission(item.module, PermissonEnum.Allow)
                    } else {
                        return true;
                    }
                }
                return false;
            };


            return {
                hasActiveChildren,
                MainMenuConfig,
                sidebarMenuIcons,
                translate,
                getAssetPath,
                checkPemission,
                currentObject
            };
        },
    });
</script>